import { useTranslation } from "react-i18next";
import faildImg from "../../../media/images/planet.png"
export default function FaildLoadData({refetchDataFunc}) {
    const {t} = useTranslation();
    return (
        <>
            <div className="relative flex flex-col justify-center items-center w-full h-[70vh]">
                <div className="faild-img relative mb-2">
                    <img src={faildImg} alt="faild img" className="w-[200px]" />
                </div>
                <p>{t("Faild Loading Data")}<span
                    className="text-blue-500 ml-1 cursor-pointer"
                    onClick={() => refetchDataFunc()}
                >{t("Try Again")}</span></p>
            </div>
        </>
    )
}